import { render, staticRenderFns } from "./VipConfirmationModal.vue?vue&type=template&id=4be1d078&"
import script from "./VipConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./VipConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports